module.exports = __webpack_public_path__ + "static/bursatilidad2-151bca63eaf957b957148e0510e0fae9.jpg";